import { css } from '@emotion/react';
import React, { forwardRef } from 'react';
import useCombinedRef from '@polestar/component-warehouse-react/hooks/useCombinedRef';
import styled from '@emotion/styled';
import useScrollProgress from '@polestar/component-warehouse-react/components/parallax/useScrollProgress';
import ParallaxRangeContext from './ParallaxRangeContext';
const ParallaxRange = forwardRef(({ children, range = '200vh', initialProgressValue, ...props }, ref) => {
    const { scrollProgressRef, progress, outerProgress } = useScrollProgress({
        initialValue: initialProgressValue,
    });
    const combinedRef = useCombinedRef(ref, scrollProgressRef);
    return (React.createElement(Container, { ref: combinedRef, range: range, ...props },
        React.createElement(InnerRange, null,
            React.createElement(ParallaxRangeContext.Provider, { value: {
                    progress,
                    outerProgress,
                    scrollProgressRef,
                } }, children))));
});
ParallaxRange.displayName = 'ParallaxRange';
export default ParallaxRange;
const Container = styled.div(({ range }) => css `
    height: ${range};
  `);
const InnerRange = styled.div `
  position: sticky;
  inset-block-start: 0;
  height: 100vh;
  overflow: hidden;
`;
